var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLattes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "2.5rem",
    height: "2.5rem",
    viewBox: "0 0 52.207 52.207",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.103 0A26.103 26.103 0 000 26.103a26.103 26.103 0 0026.103 26.104 26.103 26.103 0 0026.104-26.104A26.103 26.103 0 0026.103 0zm-.89 4.698c1.477.023 2.981.194 4.48.533 3.012.68 5.672 2.892 8.153 4.482C24.065 6.98 15.617 15.564 23.47 29.788c0 0-5.05.676-12.588 1.585-3.328-10.624-2.132-17.436-.55-20.076 2.613-3.992 8.482-6.695 14.88-6.599zm5.033 6.552a7.834 7.834 0 017.834 7.835 7.834 7.834 0 01-7.834 7.834 7.834 7.834 0 01-7.834-7.834 7.834 7.834 0 017.834-7.835zm8.157 2.583c19.758 15.98-7.24 29.58-21.146 34.07l-3.566-8.916-2.807-7.265c4.621-.359 10.4-1.097 15.08-2.016 9.183-2.167 17.227-5.594 12.44-15.873z",
    paintOrder: "fill markers stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLattes);
export default __webpack_public_path__ + "static/media/lattes.57a7183fd2a7d7af368769d553dc4d73.svg";
export { ForwardRef as ReactComponent };